import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { DashboardLink } from 'utils/link';
import { ButtonLink } from 'components/styles_components/link';
import Container from 'components/layout/container';
import Logo from 'components/layout/logo';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Box sx={{ p: 2 }}>
        <ButtonLink to={DashboardLink()}>
          <Logo width={40} />
        </ButtonLink>
      </Box>
      <Container>
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: '60vh' }}>
          <Stack spacing={2} alignItems="center" textAlign="center">
            <Typography variant="h1" sx={{ fontSize: 80, fontWeight: 700 }}>
              404
            </Typography>
            <Typography variant="h5">
              <FormattedMessage id="not_found.title" />
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              <FormattedMessage id="not_found.message" />
            </Typography>
            <Button variant="contained" onClick={() => navigate(DashboardLink())}>
              <FormattedMessage id="button.go_to_dashboard" />
            </Button>
          </Stack>
        </Box>
      </Container>
    </>
  );
};

export default NotFound;
